module.exports = __webpack_public_path__ + "img/rs.984efce5.svg";